/**
 * Genera un UUID v4 compatible con todos los navegadores
 * Intenta usar crypto.randomUUID() si está disponible,
 * de lo contrario usa un fallback manual
 */
export const generateUUID = (): string => {
  // Intentar usar crypto.randomUUID si está disponible (navegadores modernos)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  
  // Fallback: generar UUID v4 manualmente
  // Compatible con todos los navegadores incluidos móviles antiguos
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
